import { isOptional } from '../types/utils/typeguards';
/**
 * Sort line items per spec, and sort related arrays to keep them in sync.
 */
export const sortLineItemArrays = ({
  lineItems,
  selectionToggles,
  lineItemErrors,
  selectedItems
}) => {
  const sortedLineItemArrays = {
    required: {
      items: [],
      toggles: [],
      errors: [],
      selections: []
    },
    selected: {
      items: [],
      toggles: [],
      errors: [],
      selections: []
    },
    nonSelected: {
      items: [],
      toggles: [],
      errors: [],
      selections: []
    }
  };
  const {
    required,
    selected,
    nonSelected
  } = lineItems.reduce((acc, lineItem, i) => {
    const {
      items,
      toggles,
      errors,
      selections
    } = !isOptional(lineItem) ? acc.required : selectedItems[i] ? acc.selected : acc.nonSelected;
    items[items.length] = lineItem;
    toggles[toggles.length] = selectionToggles[i];
    errors[errors.length] = lineItemErrors[i];
    selections[selections.length] = selectedItems[i];
    return acc;
  }, sortedLineItemArrays);
  return [[...required.items, ...selected.items, ...nonSelected.items], [...required.toggles, ...selected.toggles, ...nonSelected.toggles], [...required.errors, ...selected.errors, ...nonSelected.errors], [...required.selections, ...selected.selections, ...nonSelected.selections]];
};